export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15')
];

export const server_loads = [];

export const dictionary = {
		"/": [2],
		"/activationPlot": [3],
		"/ameoActivationTest": [4],
		"/binaryActivation": [5],
		"/classificationDemo": [6],
		"/functionComplexity": [7],
		"/gatedFSMDemo": [8],
		"/loadWeights": [~9],
		"/nodeViz": [10],
		"/rnn": [11],
		"/sparseRegularizerPlot": [12],
		"/ternary": [13],
		"/train": [14],
		"/voxelViz": [15]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
};

export { default as root } from '../root.svelte';